<template>
  <div class="content">
    <div class="container">
      <h1 class="mb-5">
        Marketing
      </h1>
      <nav-marketing tab="google" />

      <google-merchant />
    </div>
  </div>
</template>

<script>
    import NavMarketing from "../components/NavMarketing";
    import GoogleMerchant from "../components/GoogleMerchant";
    export default {
        name: "Marketing",
        components: {GoogleMerchant, NavMarketing},
        data:function() {
            return {
                tab:'google'
            }
        },
        mounted() {
            this.$store.commit('ACTIVE_SIDEBAR', 'marketing')
        }
    }
</script>

<style scoped>

</style>